import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function TargetAudienceSection() {
  return <section className="py-14 md:py-24 bg-deep-black" data-id="element-233">
      <div className="max-w-5xl mx-auto px-6" data-id="element-234">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-235">
          <FadeIn direction="right" data-id="element-236">
            <div className="bg-glass-burgundy backdrop-blur-md border border-champagne-gold/30 rounded-3xl p-10 h-full" data-id="element-237">
              <div className="w-12 h-12 bg-champagne-gold/20 rounded-full flex items-center justify-center mb-8" data-id="element-238">
                <Check className="text-champagne-gold w-6 h-6" data-id="element-239" />
              </div>
              <h3 className="font-playfair text-3xl text-cream mb-8" data-id="element-240">
                C'est pour toi si :
              </h3>
              <ul className="space-y-6" data-id="element-241">
                {['Tu en as marre de perdre ton temps sur des apps qui ne donnent rien.', 'Tu veux des rendez-vous réels avec des hommes qui font des efforts.', 'Tu veux redevenir la sélectionneuse, pas la chassée.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-242">
                    <div className="w-1.5 h-1.5 rounded-full bg-champagne-gold mt-2.5 flex-shrink-0" data-id="element-243"></div>
                    <p className="text-muted-cream font-light leading-relaxed" data-id="element-244">
                      {text}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn direction="left" delay={0.2} data-id="element-245">
            <div className="bg-deep-black border border-white/10 rounded-3xl p-10 h-full opacity-80" data-id="element-246">
              <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center mb-8" data-id="element-247">
                <X className="text-white/40 w-6 h-6" data-id="element-248" />
              </div>
              <h3 className="font-playfair text-3xl text-white/60 mb-8" data-id="element-249">
                Ce n'est pas pour toi si :
              </h3>
              <ul className="space-y-6" data-id="element-250">
                {['Tu cherches une solution magique sans rien changer.', 'Tu aimes attendre et souffrir en silence.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-251">
                    <div className="w-1.5 h-1.5 rounded-full bg-white/20 mt-2.5 flex-shrink-0" data-id="element-252"></div>
                    <p className="text-white/40 font-light leading-relaxed" data-id="element-253">
                      {text}
                    </p>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}